class CustomUpsellProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.instantAdd = false;

    if (this.dataset.productId) {
      this.instantAdd = true;
      this.fetchRecommendations(this.dataset.productId, this.dataset.intent);
    }

    this.setupEventListeners();
    this.addObserver();
  }

  setupEventListeners() {
    this.addEventListener("upsell:add", (event) => {
      if (this.instantAdd) {
        this.addToCart(event.detail);
        return;
      }

      this.closest("flexa-converter-summary").dispatchEvent(
        new CustomEvent("upsell:add", { detail: event.detail })
      );
    });
  }

  addObserver() {
    const mutationCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type !== "attributes" || mutation.attributeName !== "data-product-id") {
          return;
        }

        this.fetchRecommendations(
          mutation.target.getAttribute("data-product-id"),
          this.dataset.intent
        );
      }
    };

    const observer = new MutationObserver(mutationCallback);
    observer.observe(this, { attributes: true });
  }

  fetchRecommendations(productId, intent = "related", callback = null) {
    fetch(
      `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=5&section_id=section-upsell-products&intent=${intent}`
    )
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, "text/html");
        const recommendations = html.querySelector("custom-upsell-products");

        if (callback) callback();

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.replaceChildren(...recommendations.children);
        }
      });
  }

  addToCart(upsellElement) {
    const formData = {
      items: [
        {
          id: upsellElement.dataset.variantId,
          quantity: 1,
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        document.dispatchEvent(new Event("theme:cart:refresh"));     
        this.fetchRecommendations(this.dataset.productId, this.dataset.intent, () => upsellElement.remove());
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("custom-upsell-products", CustomUpsellProducts);

class CustomUpsellProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener("click", (event) => {
      this.classList.toggle("custom-upsell-product--selected");

      this.closest("custom-upsell-products").dispatchEvent(
        new CustomEvent("upsell:add", { detail: this })
      );
    });
  }
}

customElements.define("custom-upsell-product", CustomUpsellProduct);
